<template lang="pug">
  .your-order(v-if="data.step=='your-order'")
    .your-order__wr
      .your-order__left
        .your-order__items(v-if="data.order")
          .your-order__item-wr(v-for="item in data.order", :key="item.id", :data-id="item.id")
            .your-order__item
              .your-order__item-left(:data-src="item.image")
                img.your-order__item-img.your-order__item-img--hide(v-if="item.image", :src="item.image")
              .your-order__item-center
                .your-order__item-center-top
                  .your-order__item-name(v-if="item.name") {{item.name}}
                  .your-order__item-description(v-if="item.description") {{item.description}}
                .your-order__item-bottom
                  .your-order__item-size(v-if="item.size",)
                    Select(:data="item.size", :productId="item.id", :count="item.count", @setCurrentSelect="changePrice")
                  .your-order__item-counter
                    button.your-order__item-counter-button.your-order__item-counter-button--dec(type="button" @click="changeCount($event, item.id, 'minus')", :class="{'your-order__item-counter-button--disabled': item.count < 2}")
                    input.your-order__item-counter-input(type="number", min="1", v-model="item.count", @input="changeCount($event, item.id, 'input')")
                    button.your-order__item-counter-button.your-order__item-counter-button--inc(type="button" @click="changeCount($event, item.id, 'plus')")
              .your-order__item-right
                .your-order__item-right-top
                  button.your-order__item-remove(@click="removeFromCartLocal($event, item.id)")
                    SvgIcon.your-order__item-remove-ico(name="remove", width="13", height="13")
                .your-order__item-right-bottom
                  .your-order__item-old-price(v-if="item.oldPrice") {{item.oldPrice.value}}
                    span {{item.oldPrice.currency}}
                  .your-order__item-price(v-if="item.price") {{item.price.value}}
                    span {{item.price.currency}}
      .your-order__right
        .your-order__right-box-wr
          .your-order__right-box
            .your-order__right-title Ваша корзина
            .your-order__right-row(v-if="data.total.sale")
              .your-order__right-param Скидка
              .your-order__right-value.your-order__right-value--sale -{{data.total.sale.value}}
                span {{data.total.sale.currency}}
            .your-order__right-row(v-if="data.total.count && data.total.price")
              .your-order__right-param Товары (#[span {{data.total.count}}])
              .your-order__right-value {{data.total.price.value}}
                span {{data.total.price.currency}}
            .your-order__right-note Доступные способы и время доставки можно выбрать при оформлении заказа
          router-link.your-order__btn-next(to="/korzina/adres-dostavki") Далее
        button.your-order__btn-clear(@click="clearCartLocal") Очистить корзину
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/yourOrder/yourOrder.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
  import {CartHelpersVue} from '@/mixins/CartHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Select from '@/components/common/select/select.vue';

  // @ is an alias to /src
  //import Events from '@/components/events/Events.vue';

export default {
  name: 'YourOrder',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, CartHelpersVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {

    }
  },

  components: {
    SvgIcon,
    Select
  },

  created() {
    EventBus.$on('updateProduct', params => {
      this.data.order.forEach((el) => {
        if(el.id == params.productId) {
          el.count = params.count;
          el.oldPrice = params.oldPrice;
          el.price = params.price;

          this.$nextTick(() => {
            let $item = $('.your-order__item-wr[data-id="' + el.id + '"]');
            $item.find('.PrologueUniVueComponentSelect__top-left-title').text(params.size.title);
            $item.find('.PrologueUniVueComponentSelect__native').val(params.size.value);
          });
        }
      });
    });

    this.$nextTick(() => {
      this.imgPreloader('your-order__item-left', 'your-order__item-img', '', 250);
      this.initFancy();
    });
  },

  methods: {
    initFancy() {
      $('.your-order__item-left').fancybox({
        src: '#popupProduct',
        touch: false,
        buttons: [],
        baseClass: 'popup-product-fancy',
        animationEffect: 'zoom-in-out',
        beforeShow: function() {
          $('.page').addClass('popup popup--effect');
          let productId = $.fancybox.getInstance().current.opts.$orig.parents('.your-order__item-wr').data('id');
          EventBus.$emit('loadPopupProduct', {productId: productId});
        },
        beforeClose: function() {
          $('.page').removeClass('popup popup--effect');
          EventBus.$emit('clearPopupProduct');
        }
      });
    },

    changePrice(res) {
      this.data.order.forEach((el) => {
        if(el.id == res.productId) {
          el.oldPrice = res.oldPrice;
          el.price = res.price;
        }
      });

      this.addToCartLocal(res.productId, res.count, res.value);
    },

    changeCount(e, productId, dir) {
      let size = $(e.target).parents('.your-order__item').find('.PrologueUniVueComponentSelect__native').val();

      if(dir == 'plus') {
        this.data.order.forEach((el) => {
          if(el.id == productId) {
            el.count = +el.count + 1;
            this.addToCartLocal(productId, el.count, size);
          }
        });
      } else if(dir == 'minus') {
        this.data.order.forEach((el) => {
          if(el.id == productId) {
            el.count = +el.count - 1;
            this.addToCartLocal(productId, el.count, size);
          }
        });
      } else if(dir == 'input') {
        this.data.order.forEach((el) => {
          if(el.id == productId) {
            if(el.count != '' && el.count > 0) {
              this.addToCartLocal(productId, el.count, size);
            }
          }
        });
      }
    },

    addToCartLocal(productId, count, size) {
      let params = {
        productId: productId,
        count: count,
        size: size
      };

      this.addToCart((res) => {
        if(this.checkProperty(res.total)) {
          this.data.total = res.total;

          this.$nextTick(() => {
            $('.header__cart-count').text(res.total.count);
          });
        }
      }, params);
    },

    removeFromCartLocal(e, productId) {
      let $item = $(e.target).parents('.your-order__item-wr');

      let params = {
        productId: productId
      };

      this.removeFromCart((res) => {
        if(this.checkProperty(res.total)) {
          this.data.total = res.total;

          this.$nextTick(() => {
            $('.header__cart-count').text(res.total.count);

            $item.stop().slideUp({
              duration: 250,
              progress: function() {
                $('.page__items').css('height', $('.page__item--active').height() + 'px');
              },
              done: function() {
                $(this).remove();

                if($('.your-order__item-wr').length < 1) {
                  EventBus.$emit('setCartEmpty');

                  $('.cart__menu, .cart__items').stop().slideUp({
                    duration: 250,
                    done: function() {

                    }
                  });

                  $('.cart__empty-wr').stop().slideDown({
                    duration: 250,
                    done: function() {
                      $('.page__items').animate({'height': $('.page__item--active').outerHeight(true) + 'px'}, 250);
                    }
                  });
                }
              }
            });
          });
        }
      }, params);
    },

    clearCartLocal() {
      this.clearCart((res) => {
        if(this.checkProperty(res.status) && res.status == 'ok' && this.checkProperty(res.count)) {
          this.$nextTick(() => {
            EventBus.$emit('setCartEmpty');
            $('.header__cart-count').text(res.count);

            $('.cart__menu, .cart__items').stop().slideUp({
              duration: 250,
              done: function() {

              }
            });

            $('.cart__empty-wr').stop().slideDown({
              duration: 250,
              done: function() {
                $('.page__items').animate({'height': $('.page__item--active').outerHeight(true) + 'px'}, 250);
              }
            });
          });
        }
      });
    }
  }
}
</script>
